import React, { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';
import PageLayout from '../components/common/pageLayout'
import {
  Box, Button, Stack, Typography, Grid, TextField, FormControl, InputLabel, Select, MenuItem,
  Tabs, Tab, IconButton, Tooltip, FormControlLabel, Checkbox, Link, Collapse, useTheme,
  Divider
} from '@mui/material';
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import RefreshIcon from '@mui/icons-material/Refresh';
import ReviewList from '../components/common/reviewComponents/reviewList';
import LogDrawer from "../components/common/reviewComponents/logDrawer";
import PipelineOutputModel from '../components/modals/pipelineOutputModel'
import { useDispatch, useSelector } from 'react-redux'
import AppConfig from '../../appConfig'
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { fetchReviews, reviewsSelector, fetchSimilarReviews } from '../../store/slices/reviews';
import { brandVoiceSelector, fetchBrandVoice } from '../../store/slices/brandVoice';
import { companiesSelector } from '../../store/slices/company';
import { fetchPromptTemplates, promptsSelector } from '../../store/slices/prompts'
import {
  getTopicsData,
  topicsSelector,
  getStandardTopicsData,
} from "../../store/slices/topics";
import { fetchGPTUsageData, logSelector, setInput } from "../../store/slices/logs";
import { fetchPipelines, fetchPipelinesUsingAkka, fetchProcessPrompts, fetchPipelinePrompt, getPipelinesData, pipelinesSelector } from '../../store/slices/pipelines'
import _ from 'lodash'
import moment from 'moment';
import { filterByValues, convertArrayToDictionary, getNumeric, defaultGuid } from '../../common/utils'
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import ReactJson from 'react-json-view';
import TuneIcon from "@mui/icons-material/Tune";
import Result from '../components/pipelines/result';
import ProcessSettings from '../components/common/processSettings';
import { Iron } from '@mui/icons-material';
import EditPrompts from '../components/modals/EditPrompts';
import { locationsSelector } from '../../store/slices/location';
const process = {
  1: 'C745803C-F072-44D1-B3F3-222E14A9C853',
  2: '840E11B0-81CA-49E5-8B50-3176822040D3',
  3: '7C2503B9-E512-49C1-A688-365D470B5923',
  4: 'FA47573C-25DC-4F3E-A9A9-E23CE8AC5F8D',
  5: 'A0CD0408-C1FE-46A7-A872-DB1481A0A247',
  6: '890E7ABB-E630-4B95-B051-1B67F431F31E'
}
const promptIds = [
  {
    promptId: '85999356-BF40-4DB7-8D33-E040C521429D',
    promptName: 'Determine Sentiments v2.1'
  },
  {
    promptId: '882CD5ED-6264-47F9-8F6B-21BFC6EC93B0',
    promptName: 'Determine Sentiments v2.1b'
  },
  {
    promptId: '45e02357-7d8c-41a2-960d-462d373fd844',
    promptName: 'Determine Sentiments v2.2'
  }]
const getStepName = (val) => {
  switch (val) {
    case 1:
      return 'Segments'

    case 2:
      return 'Summarize'

    case 3:
      return 'TopicGeneration'
    case 5:
      return 'Generic'
    case 6:
      return 'RelevanceExampleAndFact'
    case 7:
      return '(V3)GenerateResponse'
    default:
      break;
  }
}
const stepsArr = [1, 2, 3]
const Pipelines = ({ isIRUser, selectedCompany, setSelectedLocation, selectedLocation, locations, startDate, endDate }) => {
  const dispatch = useDispatch()
  const { reviews, similarReviews, loadingReviews } = useSelector(reviewsSelector);
  const { responseData, pipelinesData, processPrompts, processLoading } = useSelector(pipelinesSelector);
  const { companyTopics, standardTopics } = useSelector(topicsSelector);

  const { brandVoice, promptTemplates } = useSelector(locationsSelector);
  const { gptUsage, apiKey } = useSelector(logSelector);
  const { companies } = useSelector(companiesSelector);
  const [selectedReviewIds, setSelectedReviewIds] = useState([])
  const [selectedReview, setSelectedReview] = useState([])
  const [selectedReviewText, setSelectedReviewText] = useState([]);
  const [selectedTab, setSelectedTab] = useState(1);
  const [topicType, setTopicType] = useState(1);
  const [openTabularOutput, setOpenTabularOutput] = useState(false);
  const [isSaveSteps, setIsSaveSteps] = useState(false);
  const [isOverwrite, setIsOverwrite] = useState(false);
  const [isUseAkkaPipelines, setIsUseAkkaPipelines] = useState(false);
  const [step, setStep] = useState(1);
  const [pipelineType, setPipelineType] = useState(localStorage.getItem('pipelineProcess') ? localStorage.getItem('pipelineProcess') : 2);
  const [promptId, setPromptId] = useState('');
  const [reviewType, setReviewType] = useState(1);
  const [reviewCount, setReviewCount] = useState(0);
  const [requestId, setRequestId] = useState(null);
  const [moreInfoState, setMoreInfoState] = useState(false)
  const [finalReviews, setFinalReviews] = useState([])
  const [isOpenSettings, setIsOpenSettings] = useState(false)
  const [showAllLogs, setShowAllLogs] = useState(false)
  const [openEditPromts, setOpenEditPrompts] = useState(false)
  const [batchRecords, setBatchRecords] = useState(1)
  const theme = useTheme();
  
  const processPromptsText = React.useMemo(() => {
    return processPrompts[getStepName(selectedTab)]?.promptText ?? ''
  }, [selectedTab, processPrompts])

  const processPromptsName = React.useMemo(() => {
    return processPrompts[getStepName(selectedTab)]?.name ?? ''
  }, [selectedTab, processPrompts])
  const selectedPrompts = React.useMemo(() => processPrompts[getStepName(selectedTab)] ?? {}, [selectedTab, processPrompts])
  const [openDrawer, setOpenDrawer] = useState(false);
  const isSerializable = function (obj) {
    if (_.isUndefined(obj) ||
      _.isNull(obj) ||
      _.isBoolean(obj) ||
      _.isNumber(obj) ||
      _.isString(obj)) {
      return true;
    }
    return false;
  }
  const bindData = (val) => {
    try {
      let val1 = _.map(val, it => {
        const isFirstKey = _.indexOf(it, '[') === 0
        const isLastKey = _.lastIndexOf(it, ']') === it?.length - 1
        it = isFirstKey ? _.trim(it, '[') : it
        it = isLastKey ? _.trim(it, ']') : it

        return it && (selectedTab === 6) ? JSON.parse(it) : it;
      })
      return JSON.parse("[" + val1 + ']');

    } catch (e) {
      return val // error in the above string (in this case, yes)!
    }
  }
  const onCloseTabularOutput = () => {
    setOpenTabularOutput(false);
  }

  const companyData = React.useMemo(
    () => _.find(companies, { companyId: selectedCompany }),
    [companies, selectedCompany]
  );
  const getSortedReviews = () => {
    if (reviews && reviews.length > 0) {
      return _.map(_.sortBy(_.cloneDeep(reviews), ["reviewDateTime"], ["desc"]), (it, index) => { it['number'] = (index + 1); return it });
    } else {
      return [];
    }
  };
  const sortedReviews = React.useMemo(
    () => getSortedReviews(),
    [reviews, startDate, endDate]
  );
  useEffect(() => {
    const value = localStorage.getItem('pipelineProcess')
    if (value) {
      setPipelineType(parseInt(value))
    }
  }, [])
  const handlePipelinesChange = (value) => {
    localStorage.setItem('pipelineProcess', parseInt(value))
    setPipelineType(value)
    if (value == 3) {
      setSelectedReview([]);
      setSelectedReviewIds([]);
      setSelectedReviewText([]);
    }
  }
  const handleLocationChange = (event) => {
    const locationId = event.target.value;
    const selectedLocation = locations.find(
      (location) => location.locationId === locationId
    );
    setSelectedLocation(locationId);

  };
  const handleCheckboxChange = (reviewId, reviewText, author, review) => {

    if (selectedReviewIds.includes(reviewId)) {
      if (pipelineType === 3) {
        setSelectedReviewIds([reviewId]);
        setSelectedReviewText([reviewText]);
        setSelectedReview([review])
      }
      else {
        setSelectedReviewIds(selectedReviewIds.filter((id) => id !== reviewId));
        setSelectedReviewText(
          selectedReviewText.filter((text) => text !== reviewText)
        );
        setSelectedReview(selectedReview.filter((text) => text !== review))
      }

    } else {
      if (pipelineType === 3) {
        setSelectedReviewIds([reviewId]);
        setSelectedReviewText([reviewText]);
        setSelectedReview([review])
      }
      else {
        setSelectedReviewIds([...selectedReviewIds, reviewId]);
        setSelectedReviewText([...selectedReviewText, reviewText]);
        setSelectedReview([...selectedReview, review]);
      }

    }

  };
  useEffect(() => {
    if (pipelineType === 3 && selectedReviewIds?.length > 0) {
      dispatch(fetchSimilarReviews(selectedReviewIds[0]))
    }
  }, [selectedCompany, pipelineType, selectedReviewIds])
  useEffect(() => {
    if (selectedCompany !== defaultGuid && selectedTab) {
      if (pipelineType === 1) {
        _.map(stepsArr, (it) =>
          dispatch(
            fetchProcessPrompts(selectedCompany, "ProcessReviews", getStepName(it))
          )
        );
      }
      else if (pipelineType === 3) {
        dispatch(fetchProcessPrompts(selectedCompany, "(V3)GenerateResponse", getStepName(selectedTab)))
      }

      else if (pipelineType === 2) {
        dispatch(
          fetchPipelinePrompt(promptId, getStepName(pipelineType === 2 ? 5 : selectedTab))
        )
      }
    }
  }, [selectedCompany, selectedTab, promptId]);
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  useEffect(() => {
    if (reviewType === 1) {
      setStep(1)
    }
  }, [reviewType])
  useEffect(() => {
    if (pipelineType === 2) {
      setPromptId(promptIds[0]?.promptId)
      setSelectedTab(5);
      // setIsSaveSteps(false)
    }
    if (pipelineType === 3) {
      setPromptId('')
      setSelectedTab(6);
      // setIsSaveSteps(false)
    }
    if (pipelineType === 1) {
      setSelectedTab(1);
      setPromptId('')
      // setIsSaveSteps(true)
    }
  }, [pipelineType])
  useEffect(() => {
    if (!isSaveSteps) {
      setIsOverwrite(false)
    }
  }, [isSaveSteps])
  useEffect(() => {
    if (
      selectedCompany !== null &&
      selectedCompany !== undefined &&
      selectedCompany !== "" &&
      startDate !== null &&
      startDate !== undefined &&
      startDate !== "" &&
      endDate !== null &&
      endDate !== undefined &&
      endDate !== ""
    ) {
      // dispatch(fetchReviews(startDate, endDate, selectedCompany));
    }
    setSelectedReviewText([])
    setSelectedReviewIds([])
  }, [selectedCompany, startDate, endDate]);
  useEffect(() => {
    setSelectedReviewText([])
    setSelectedReviewIds([])
  }, [selectedLocation])

  useEffect(() => {
    if (selectedCompany) {
      const processName = pipelineType === 1 ? 'ProcessReviews' : pipelineType === 2 ? 'ProcessReviewsForTopics' : '(V3)GenerateResponse'
      dispatch(setInput({ "Process": processName }))
    }
  }, [pipelineType, selectedCompany]);
  const fetchRequestData = () => {
    if (requestId) {
      dispatch(getPipelinesData(requestId));
    }
  }
  // useEffect(() => {
  //   if (requestId)
  //     dispatch(getPipelinesData(requestId));
  // }, []);
  // useEffect(() => {
  //   if (companyData?.businessType)
  //     dispatch(getStandardTopicsData(companyData?.businessType));
  // }, [companyData?.businessType]);

  const selectedPos = React.useMemo(() => _.find(brandVoice, { isDefault: true }), [brandVoice]);
  const selectedNeg = React.useMemo(() => _.find(brandVoice, { isDefaultNegative: true }), [brandVoice]);
  // console.log('selectedPos', selectedPos)
  // console.log('selectedNeg', selectedNeg)
  // const output1 = React.useMemo(() => bindData(responseData?.length > 0 ? responseData?.[0] : ''), [responseData, selectedReviewIds])
  // const output2 = React.useMemo(() => bindData(responseData?.length > 1 ? responseData?.[1] : ''), [responseData, selectedReviewIds])
  // const output3 = React.useMemo(() => bindData(responseData?.length > 2 ? responseData?.[2] : ''), [responseData, selectedReviewIds])
  // const output4 = React.useMemo(() => bindData(responseData?.length > 3 ? responseData?.[3] : ''), [responseData, selectedReviewIds])
  // const output5 = React.useMemo(() => bindData(responseData?.length > 4 ? responseData?.[4] : ''), [responseData, selectedReviewIds])
  const processResponseData = React.useMemo(() => isUseAkkaPipelines ? pipelinesData[process[step]] : responseData[process[pipelineType === 1 ? step : pipelineType === 3 ? 6 : 5]], [responseData, pipelinesData, isUseAkkaPipelines, pipelineType])
  const output1 = React.useMemo(() => isUseAkkaPipelines ? processResponseData?.segments : bindData(processResponseData?.length > 0 ? processResponseData?.[0] : ''), [selectedReviewIds, processResponseData, selectedTab])
  const output2 = React.useMemo(() => isUseAkkaPipelines ? processResponseData?.summarization : bindData(processResponseData?.length > 1 ? processResponseData?.[1] : ''), [selectedReviewIds, processResponseData])
  const output3 = React.useMemo(() => isUseAkkaPipelines ? processResponseData?.summarizationTopics : bindData(processResponseData?.length > 2 ? processResponseData?.[2] : ''), [selectedReviewIds, processResponseData])
  const output4 = React.useMemo(() => bindData(processResponseData?.length > 3 ? processResponseData?.[3] : ''), [processResponseData, selectedReviewIds])
  const output5 = React.useMemo(() => bindData(processResponseData?.length > 4 ? processResponseData?.[4] : ''), [processResponseData, selectedReviewIds])
  const output = React.useMemo(() => selectedTab === 1 || selectedTab === 5 ? output1 : selectedTab === 2 ? output2 : selectedTab === 3 ? output3 : selectedTab === 4 ? output4 : selectedTab === 5 ? output5 : selectedTab === 6 ? output1 : selectedTab === 7 ? output2 : '', [output1, output2, output3, output4, output5, selectedTab])
  // const output = React.useMemo(() => bindData(responseData?.[1]), [responseData, selectedReviewIds])
  // console.log('output2', processResponseData?.[0])
  const caseSensitive = (key) => {
    return isUseAkkaPipelines ? key : _.upperFirst(key);
  }
  const comaprisionTopicsData = () => {
    let outputTopic = _.map(_.groupBy(output3 ?? [], caseSensitive('reviewId')), (items, reviewId) => {
      return {
        reviewId, topicArray: _.map(items, it => {
          return it[caseSensitive('topic')] + ':' + it[caseSensitive('sentiment')]
        }
        )
      }
    });
    let outputDic = convertArrayToDictionary(outputTopic, 'reviewId')
    var reviewIds = _.uniq(_.map(output3, caseSensitive('reviewId')));
    let filteredData = filterByValues(finalReviews, 'reviewId', reviewIds);
    let filnalData = _.map(filteredData, it => {
      const outputData = outputDic[it.reviewId]?.topicArray
      const topicArr = _.split(it?.topicData, ',')
      const missingInOriginal = _.filter(outputData, it => { return !_.includes(topicArr, it) });
      const missingInOutput = _.filter(topicArr, it => { return !_.includes(outputData, it) })
      const matchingOutput = _.filter(topicArr, it => { return _.includes(outputData, it) })
      return {
        number: it?.number,
        reviewId: it.reviewId,
        original: topicArr,
        missingInOutput: missingInOutput,
        matchingOutput: matchingOutput,
        missingInOriginal: missingInOriginal,
        output: outputData,
        matchingScore: topicArr?.length > 0 ? ((topicArr?.length - missingInOutput?.length) / topicArr?.length) * 100 : 0
        //return _.map(topicArr, it => { return _.includes(outputData, it) ? 1 : 0 })
      }
    });
    return filnalData;
  }
  const comaprisionGenericTopicData = () => {
    const dic = output2?.[0];
    let d = _.flatMapDeep(output1, it => {
      let keys = _.keys(it);
      return _.map(keys, key => {
        let value = it[key];
        return _.map(_.keys(value), obj => {
          let arr = _.split(obj, ':')
          return { Topic: arr?.length > 1 ? arr?.[1] : null, Sentiment: arr?.length > 2 ? arr?.[2] : value[obj]?.Sentiment, ReviewId: dic[key] }
        })
      })
    })
    // console.log(d)
    let outputTopic = _.map(_.groupBy(d ?? [], caseSensitive('reviewId')), (items, reviewId) => {
      return {
        reviewId, topicArray: _.map(items, it => {
          return it[caseSensitive('topic')] + ':' + it[caseSensitive('sentiment')]
        }
        )
      }
    });
    let outputDic = convertArrayToDictionary(outputTopic, 'reviewId')
    var reviewIds = _.uniq(_.map(outputTopic, 'reviewId'));
    let filteredData = filterByValues(finalReviews, 'reviewId', reviewIds);
    let filnalData = _.map(filteredData, it => {
      const outputData = outputDic[it.reviewId]?.topicArray
      const topicArr = _.split(it?.topicData, ',')
      const missingInOriginal = _.filter(outputData, it => { return !_.includes(topicArr, it) });
      const missingInOutput = _.filter(topicArr, it => { return !_.includes(outputData, it) })
      const matchingOutput = _.filter(topicArr, it => { return _.includes(outputData, it) })
      return {
        number: it?.number,
        reviewId: it.reviewId,
        original: topicArr,
        missingInOutput: missingInOutput,
        matchingOutput: matchingOutput,
        missingInOriginal: missingInOriginal,
        output: outputData,
        matchingScore: topicArr?.length > 0 ? ((topicArr?.length - missingInOutput?.length) / topicArr?.length) * 100 : 0
        //return _.map(topicArr, it => { return _.includes(outputData, it) ? 1 : 0 })
      }
    });
    return filnalData;
  }
  const bindTopicWithCategory = (data) => {
    const parentData = _.filter(data, {
      parentTopicId: null,
    })
    const parents = convertArrayToDictionary((parentData), 'topicId');
    const topic = _.filter(data, it => {
      return it.parentTopicId
    });
    const topicsMapping = _.reduce(topic, function (result, value, key) {
      result[value.name] = parents[value.parentTopicId]?.name
      return result;
    }, {});
    _.map(parentData, it => {
      topicsMapping[it.name + ' Other'] = it.name;
    })
    return topicsMapping;
  };
  const acheivePercentageOld = () => {
    //const key = isUseAkkaPipelines ? pipelinesData?.summarizationTopics : o
    let outputTopic = _.map(_.groupBy(output3 ?? [], caseSensitive('reviewId')), (items, reviewId) => {
      return {
        reviewId, topicArray: _.map(items, it => {
          return it[caseSensitive('topic')] + ':' + it[caseSensitive('sentiment')]
        }
        )
      }
    });
    let outputDic = convertArrayToDictionary(outputTopic, 'reviewId')
    var reviewIds = _.uniq(_.map(output3, caseSensitive('reviewId')));
    let filteredData = filterByValues(finalReviews, 'reviewId', reviewIds);
    let filnalData = _.flatMapDeep(filteredData, it => {
      let outputData = outputDic[it.reviewId]?.topicArray
      let topicArr = _.split(it?.topicData, ',')
      return _.map(topicArr, it => { return _.includes(outputData, it) ? 1 : 0 })
    });
    return filnalData?.length > 0 ? (_.sum(filnalData) / filnalData?.length) * 100 : 0;
  }
  const acheivePercentage = (comparisionData) => {
    let filnalData = _.flatMapDeep(comparisionData, it => {
      let outputData = it.output
      let topicArr = it.original
      return _.map(topicArr, it => { return _.includes(outputData, it) ? 1 : 0 })
    });
    return filnalData?.length > 0 ? (_.sum(filnalData) / filnalData?.length) * 100 : 0;
  }
  const comparisionData = React.useMemo(() => pipelineType === 1 ? comaprisionTopicsData() : pipelineType === 2 ? comaprisionGenericTopicData() : [], [output3, pipelineType, output])
  const acheiveData = React.useMemo(() => acheivePercentage(comparisionData), [comparisionData])
  // console.log('acheiveData', acheiveData);
  const topicData = React.useMemo(
    () =>
      topicType == 1 ? _.cloneDeep(companyTopics) : _.cloneDeep(standardTopics),
    [topicType, companyTopics, standardTopics]
  );
  const formattedData = React.useMemo(() => {
    const nestedTopics = _.groupBy(topicData, "parentTopicId");

    const formattedData = {};

    _.forEach(_.orderBy(nestedTopics[null], "sequence"), (parentTopic) => {
      const parentName = parentTopic.name;
      const childTopicsWithDescription = _.map(
        _.orderBy(nestedTopics[parentTopic.topicId], "sequence"),
        (childTopic) => `${childTopic.name}-${childTopic.description}`
      );
      formattedData[parentName] = childTopicsWithDescription;
    });

    return formattedData;
  }, [topicData]);
  const topicWithCategory = React.useMemo(() => bindTopicWithCategory(topicData) ?? {}, [topicData])
  const bindTemplates = () => {
    let obj = { topicArray: '', topicArrayWithDesc: '' };
    const data = _.find(promptTemplates, { value: 'Category And Topics Array' });
    if (Object.keys(formattedData)?.length > 0) {
      let res = [];
      const result = _.map(formattedData, (value, key) => {
        res = _.concat(res, _.map(value, it => {
          return `${key}: ${it.split("-")[0]}`;
        }))
        res = _.concat(res, `${key}: Other`);
      });
      obj.topicArray = `${data?.promptText}\n\n[\n${_.join(res, ",")}\n]`;
    }
    const data1 = _.find(promptTemplates, { value: 'Category And Topics With Description Array' });
    let res1 = [];
    const result = _.map(formattedData, (value, key) => {
      res1 = _.concat(res1, _.map(value, it => {
        return `{"Topic":"${key}: ${it.split("-")[0]}","Description":"${it.split("-")[1]}"}`;
      }))
      res1 = _.concat(res1, `{"Topic":"${key}: Other}","Description":""}`);
    });
    obj.topicArrayWithDesc = `${data1?.promptText}\n\n[\n${_.join(res1, ",")}\n]`;
    return obj;
  }

  const topicTemplates = React.useMemo(() => bindTemplates(), [formattedData, promptTemplates])

  const handleFetch = () => {
    const data = _.map(selectedReviewText, (it, i) => {
      let reviewId = selectedReviewIds[i]
      return JSON.stringify({ ReviewId: reviewId, ReviewText: it })
    })
    let params = {
      apiKey: apiKey, TopicTemplate: topicTemplates?.topicArray, TopicTemplateWithDescription: topicTemplates?.topicArrayWithDesc,
      promptId: pipelineType === 2 ? promptId : null,
    }
    if (pipelineType === 2) {
      params = { ...params, batchRecords: _.toString(batchRecords) }
    }
    if (pipelineType === 3) {
      params = { ...params, ReviewId: selectedReviewIds?.[0] }
    }
    if (_.size(data) > 0 || reviewType === 2) {
      let rId = uuidv4();
      if (isUseAkkaPipelines) {
        setRequestId(rId)
        dispatch(fetchPipelinesUsingAkka(process[step], selectedCompany, localStorage.getItem("userId")
          ? localStorage.getItem("userId")
          : AppConfig.env("userId"), reviewType === 2 ? null : data, params, isSaveSteps, reviewType === 1 ? 0 : reviewCount, isOverwrite, rId, startDate, endDate))
      }
      else {
        const processId = pipelineType === 1 ? process[step] : pipelineType === 3 ? process[6] : process[5];
        if (pipelineType === 3 && selectedReviewText?.length > 0) {
          const topics = _.map(selectedReview[0]?.topics, it => {
            return { category: topicWithCategory[it.topic], sentiment: it.sentiment }
          })
          const values = _.map(_.groupBy(topics, 'category'), (items, key) => {
            const sentiments = _.uniq(_.map(items, 'sentiment'))
            return `${key}:${sentiments?.length > 1 ? 'Negative' : sentiments[0]}`
          })
          // formattedRating = JSON.stringify(values)

          params = {
            ...params, Review: selectedReviewText[0],
            IsSingle: 'true',
            Rating: `${selectedReview[0].rating}`,
            WordLength: '50',
            // FactsArray: `[${_.join((_.take(_.map(similarReviews?.facts, it => { return `"${it.fact}"` }), 3)), ',')}]`,
            // ExamplesArray: `[${_.join((_.take(_.map(similarReviews?.exampleReviews, it => { return `{ "Review": "${it.reviewText}", "Response": "${it.responseText}" }` }), 3)), ',')}]`,
            //CategorySentimentsArray: `[${_.join(values, ',')}]`,
            Voice: (selectedReview[0].rating > 3 ? selectedPos?.description ?? '' : selectedReview[0].rating < 4 ? selectedNeg?.description ?? '' : ''),
            FactsArray: JSON.stringify((_.take(_.map(similarReviews?.response?.facts??[], 'fact'), 3))),
            ExamplesArray: JSON.stringify((_.take(_.map(similarReviews?.exampleReviews??[], it => { return { Review: it.reviewText, Response: it.responseText } }), 3))),
            CategorySentimentsArray: JSON.stringify(values)

          }
        }
        dispatch(fetchPipelines(processId, selectedCompany, localStorage.getItem("userId")
          ? localStorage.getItem("userId")
          : AppConfig.env("userId"), reviewType === 2 ? null : data, params, isSaveSteps, reviewType === 1 ? 0 : reviewCount, isOverwrite, rId, startDate, endDate))
      }
    }
  }

  const handleOpenSettings = (event) => {
    setIsOpenSettings(event.currentTarget)
  }

  return (
    <Box sx={{ pt: '10px' }}>
      {/* <Stack sx={{ mt: '15px' }} direction='row' justifyContent={'space-between'} alignItems={'center'}> */}

      {/* <Typography variant='h4'>Pipelines</Typography> */}


      {/* </Stack> */}
      <Grid container spacing={2} >
        <Grid item xs={6}>
          <ReviewList
            isPipeline={true}
            setFinalReviews={setFinalReviews}
            data={sortedReviews}
            startDate={startDate}
            endDate={endDate}
            selectedCompany={selectedCompany}
            selectedLocation={selectedLocation}
            isMultiple={pipelineType === 3 ? false : true}
            singleSelectFunction={handleCheckboxChange}
            selectedReviewIds={selectedReviewIds}
            setSelectedReviewIds={setSelectedReviewIds}
            setSelectedReviewText={setSelectedReviewText}
            reviewHeight={165}
          />
        </Grid>
        <Grid item xs={6} >
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center', mt: 1,
            flexWrap: 'wrap',
             rowGap: '8px'
          }}>
            <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
              <FormControl variant="outlined">
                <InputLabel>Pipeline</InputLabel>
                <Select
                  label="Pipeline"
                  size="small"
                  value={pipelineType}
                  sx={{ width: '400px' }}
                  // disabled={reviewType === 1}
                  onChange={(e) => handlePipelinesChange(e.target.value)}
                >
                  <MenuItem value={2}>Topic Sentiments (With Explanations)</MenuItem>
                  <MenuItem value={3}>Response (With Relevant Examples/Facts)</MenuItem>
                </Select>
              </FormControl>

              {
                <Tooltip title="Other options">
                  <IconButton
                    fontSize="small"
                    sx={{ cursor: "pointer", mr: 2 }}
                    onClick={handleOpenSettings}
                    disabled={(!isIRUser || pipelineType == 3)}
                  >
                    <TuneIcon />
                  </IconButton>
                </Tooltip>
              }
              <Button variant='contained' disabled={processLoading || (pipelineType === 3 && loadingReviews)} sx={{ width: 'fit-content', height: 'fit-content', textTransform: "none" }} size='small' onClick={(e) => { handleFetch(); e.preventDefault(); e.stopPropagation(); }}>Run</Button>

              {/* <FormControl sx={{ ml: 10 }} variant="outlined">
                <InputLabel>Topic Template</InputLabel>
                <Select
                  label="Topic Template"
                  size="small"
                  value={topicType}
                  onChange={(e) => setTopicType(e.target.value)}
                >
                  <MenuItem value={1}>Existing Topics</MenuItem>
                  <MenuItem value={2}>Standard Business Specific Topics</MenuItem>
                </Select>
              </FormControl> */}
              {/* {isIRUser && */}

              {/* <>

                <FormControl sx={{ ml: 8 }} variant="outlined">
                  <InputLabel>Get Reviews</InputLabel>
                  <Select
                    label="Get Reviews"
                    sx={{ width: '110px' }}
                    size="small"
                    value={reviewType}
                    disabled={!isIRUser}
                    onChange={(e) => setReviewType(e.target.value)}
                  >
                    <MenuItem value={1}>From UI</MenuItem>
                    <MenuItem value={2}>From DB</MenuItem>
                  </Select>
                </FormControl>
                <FormControl sx={{ ml: 2 }} variant="outlined">
                  <InputLabel>Steps</InputLabel>
                  <Select
                    label="Steps"
                    size="small"
                    value={step}
                    disabled={reviewType === 1}
                    onChange={(e) => setStep(e.target.value)}
                  >
                    <MenuItem value={1}>All Steps</MenuItem>
                    <MenuItem value={2}>Step 1</MenuItem>
                    <MenuItem value={3}>Step 2</MenuItem>
                    <MenuItem value={4}>Step 3</MenuItem>
                  </Select>
                </FormControl>
              </> */}
              {/* } */}
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {/* {isIRUser &&
                    <TextField
                      size="small"
                      type='number'
                      label="Count"
                      variant="outlined"
                      disabled={reviewType === 1}
                      inputProps={{ sx: { width: 70 } }}
                      sx={{ mr: 2 }}
                      value={reviewCount ?? 0}
                      onChange={(e) => setReviewCount(e.target.value)}
                    />
                  } */}
                  {/* <Box>
                    <Box>
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            sx={{ py: 0, lh: 0.5 }}
                            checked={isSaveSteps}
                            disabled={true}
                            onChange={(e) =>
                              setIsSaveSteps(e.target.checked)
                            }
                          />
                        }
                        label="Save Steps"
                      />
                    </Box>
                    <Box>
                      <FormControlLabel
                        control={
                          <Checkbox
                            sx={{ py: 0, lh: 0.5 }}
                            size="small"
                            checked={isOverwrite}
                            disabled={!isIRUser || !isSaveSteps}
                            onChange={(e) =>
                              setIsOverwrite(e.target.checked)
                            }
                          />
                        }
                        label="Overwrite Topics"
                      />
                    </Box>
                  </Box> */}
                  {/* <Button variant='contained' sx={{ marginRight: 2, width: 'fit-content', height: 'fit-content' }} onClick={() => handleSaveSummarization()}>Summarized</Button> */}
                </Box>
              }
              {/* <Button
                variant="outlined"
                color="primary"
                onClick={() => setOpenTabularOutput(true)}
                sx={{ textTransform: 'none', mr: 2 }}

              >Tabular Output </Button> */}
              {/* <Button variant='contained' sx={{ width: 'fit-content', height: 'fit-content' }} onClick={() => handleFetch()}>Run</Button> */}
            </Box>
            <Box sx={{
              display: 'flex',
              //justifyContent: 'space-between',
              alignItems: 'center',
            }}>
              {pipelineType === 2 &&
                    <FormControl variant="outlined" sx={{ width: '400px' }}>
                      <InputLabel>Prompt</InputLabel>
                      <Select
                        label="Pipeline"
                        size="small"
                        value={promptId}
                        sx={{
                          width: '400px',
                          '& .MuiPaper-root': {
                            width: '400px',
                          },
                        }}
                        disabled={pipelineType === 1}
                        onChange={(e) => setPromptId(e.target.value)}
                        MenuProps={{ sx: { width: '400px' } }}
                      >
                        {_.map(promptIds, it => {
                          return <MenuItem sx={{ textWrap: 'wrap' }} key={it.promptId} value={it.promptId}>{it.promptName}</MenuItem>
                        })}

                      </Select>
                    </FormControl>
              }
              {pipelineType === 2 &&
                <TextField
                  size="small"
                  type='number'
                  label="Batch Records"
                  variant="outlined"
                  min={0}
                  //disabled={data.reviewSource === 1}
                  inputProps={{ sx: { width: 90 } }}
                  sx={{ ml: 2, }}
                  value={batchRecords < 0 ? 0 : batchRecords ?? 0}
                  onChange={(e) => setBatchRecords(e.target.value < 0 ? 0 : e.target.value)}
                />
              }
            </Box>
          </Box>
          <Divider sx={{ mt: 0.5 }} />
          <Box>
            {requestId &&
              <Box>
                Request {requestId} has been submitted.
                <Link sx={{ cursor: 'pointer', ml: 1 }} onClick={() => fetchRequestData()}>Click to see output</Link>
              </Box>
            }
          </Box>
          <Box className='dynamic-scroll-container' sx={{ height: pipelineType === 2 ? 'calc(100vh - 160px)' : 'calc(100vh - 200px)' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                sx={{ mt: 2, maxWidth: '100%' }}
                variant={pipelineType == 1 ? "scrollable" : ""}
                scrollButtons="auto"
              >
                {pipelineType == 2 && <Tab value={5} sx={{ textTransform: "none" }} label="Output" />}
                {pipelineType == 1 && <Tab value={1} sx={{ textTransform: "none" }} label="1. Segmentations" />}
                {/* <Tab value={2} sx={{ textTransform: "none" }} label="2a. Summarizations" /> */}
                {pipelineType == 1 && <Tab value={2} sx={{ textTransform: "none", whiteSpace: 'pre-line' }} label='2. Summarizations (Segments)' />}
                {pipelineType == 1 && <Tab value={3} sx={{ textTransform: "none" }} label="3. Topics" />}
                {pipelineType == 3 && <Tab value={6} sx={{ textTransform: "none" }} label="1. Relevant Examples/Facts" />}
                {pipelineType == 3 && <Tab value={7} sx={{ textTransform: "none" }} label="2. Generated Response" />}
                {pipelineType != 3 && <Tab value={4} sx={{ textTransform: "none" }} label={"Score" + ((pipelineType === 1 ? output3 : output1)?.length > 0 ? (' (' + getNumeric(acheiveData, true) + '%)') : "")} />}
                {/* <Tab value={4} sx={{ textTransform: "none", whiteSpace: 'pre' }} label="3b. Topics (With Desc)" /> */}

              </Tabs>
              <Tooltip title={"Logs"}>
                <div>
                  <IconButton
                    // sx={{ mt: 0.5 }}
                    size="small"
                    variant="contained"
                    onClick={() => setOpenDrawer(true)}
                  >
                    <TextSnippetIcon />
                  </IconButton>
                </div>
              </Tooltip>
            </Box>

            {selectedTab !== 4 &&
              <>
                <div style={{ marginTop: '16px' }}>
                  <Collapse in={moreInfoState}>
                    <Typography sx={{ mb: 1 }}>{'Prompt: ' + processPromptsName}<Link onClick={() => setOpenEditPrompts(true)} sx={{ ml: 3, cursor: 'pointer' }}><BorderColorIcon fontSize='14px' />Edit</Link></Typography>

                    <TextField multiline maxRows={10} disabled fullWidth value={processPromptsText} />
                  </Collapse>
                  <Link component='button' onClick={() => setMoreInfoState(prev => !prev)} >{moreInfoState ? 'Less' : 'More'} Info</Link>
                </div>
              </>
            }
            <Box sx={{ mt: 2, overflow: 'auto' }} className='scrollable'>
              {selectedTab !== 4 &&
                <>
                  {typeof (output) === 'string' &&
                    output
                  }
                  {typeof (output) !== 'string' &&
                    <ReactJson src={output} key={'text'} displayDataTypes={false} name={false} theme={theme.palette.mode === 'dark' ? 'pop' : 'rjv-default'} />

                  }
                </>
              }
              {selectedTab === 4 &&
                <Result comparisionData={comparisionData} />
              }
            </Box>
            {/* <Box sx={{ mt: 2 }}>
              <Stack variant={'subtitle2'} sx={{ mb: 2 }}>Summarize Output</Stack>
              {typeof (output2) === 'string' &&
                output2
              }
              {typeof (output2) !== 'string' &&
                <ReactJson src={output2} key={'text'} displayDataTypes={false} name={false} />

              }
            </Box> */}
          </Box>


        </Grid>
      </Grid>
      {openDrawer && <LogDrawer
        openDrawer={openDrawer}
        toggleDrawer={setOpenDrawer}
        gptUsage={gptUsage}
        isShowMaxRequestId={true}
        showAll
        showAllLogs={showAllLogs}
        setShowAllLogs={setShowAllLogs}
        selectedCompany={selectedCompany}
      // selectedReviewText={selectedReviewText}
      // selectedReviewIds={selectedReviewIds}
      />}
      {
        openTabularOutput &&
        <PipelineOutputModel
          reviews={reviews}
          open={openTabularOutput}
          onClose={onCloseTabularOutput}
          rawData={{ segments: output1, summarize: output3, summarizeSegments: output2, topics: output4, topicsWithDesc: output5 }}
        />
      }
      {isOpenSettings && <ProcessSettings data={
        {
          reviewSource: reviewType,
          setReviewSource: setReviewType,
          steps: step,
          setSteps: setStep,
          count: reviewCount,
          setCount: setReviewCount,
          saveSteps: isSaveSteps,
          setSaveSteps: setIsSaveSteps,
          overWriteTopics: isOverwrite,
          setOverWriteTopics: setIsOverwrite,
        }}
        open={Boolean(isOpenSettings)}
        onClose={setIsOpenSettings}
        anchorEl={isOpenSettings}
      />
      }
      {openEditPromts && selectedPrompts?.promptId && <EditPrompts open={openEditPromts} handleClose={() => setOpenEditPrompts(false)} companyId={selectedCompany} selectedPrompt={selectedPrompts} />}
    </Box >
  )
}

export default Pipelines
